import { c as _c } from "react/compiler-runtime";
import Button from "@components/blocks/Button";
import SimpleRichText from "@components/SimpleRichText";
import StrapiImage from "@components/StrapiImage";
import { Title } from "@justhome/react-ui";
import useGlobalContext from "@lib/hooks/useGlobalContext";
import { BudgetCheckStepId } from "@modules/application/lib/budgetCheck/types";
import { memo } from "react";
import { FieldValues } from "../DynamicForm";
import { FormStep, NextStep } from "../FormSteps/FormSteps";
import ProcessSteps from "../ProcessSteps";
export interface ApplicationStepsProps<T extends FieldValues> {
  step: FormStep<T>;
  value: any;
  state: number;
  steps: NextStep[];
  onPrevious: (stepId?: string) => void;
}
const AsideQuestion = memo(function AsideQuestion() {
  const $ = _c(20);
  const context = useGlobalContext();
  const applicationData = context.siteData?.applicationProcess;
  const openQuestion = applicationData?.data?.attributes?.openQuestion;
  if (!openQuestion) {
    return null;
  }
  let t0;
  if ($[0] !== openQuestion.image) {
    t0 = <div className="rounded-full border border-neutral-50 flex overflow-hidden bg-neutral-50"><StrapiImage alt="" width="80" height="80" image={openQuestion.image} /></div>;
    $[0] = openQuestion.image;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== openQuestion.title) {
    t1 = <Title as="h3" className="text-h4 font-normal">{openQuestion.title}</Title>;
    $[2] = openQuestion.title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className="flex items-center gap justify-between">{t0}{t1}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== openQuestion.description) {
    t3 = <SimpleRichText size="small" className="text-body-2 mb-3xs mt-2xs">{openQuestion.description}</SimpleRichText>;
    $[7] = openQuestion.description;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== openQuestion.buttons) {
    t4 = openQuestion.buttons && openQuestion.buttons.map(_temp);
    $[9] = openQuestion.buttons;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== openQuestion.button) {
    t5 = openQuestion.button && <Button {...openQuestion.button} />;
    $[11] = openQuestion.button;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className="flex gap-2s mt-3xs">{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t6) {
    t7 = <div className="mt-3s flex flex-col">{t2}{t3}{t6}</div>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
});
const ApplicationSteps = t0 => {
  const $ = _c(12);
  const {
    steps,
    step,
    onPrevious
  } = t0;
  let t1;
  if ($[0] !== onPrevious || $[1] !== step || $[2] !== steps) {
    let t2;
    if ($[4] !== onPrevious || $[5] !== step) {
      t2 = (s, index) => {
        if ([BudgetCheckStepId.loading, BudgetCheckStepId.contact].includes(s.id as BudgetCheckStepId)) {
          return null;
        }
        return <ProcessSteps.Step onPreviousStep={() => onPrevious(s.id)} index={index} key={s.label} label={s.label || ""} completed={!!s.completed || !!step.isResult} selected={step.id === s.id} />;
      };
      $[4] = onPrevious;
      $[5] = step;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = steps.map(t2);
    $[0] = onPrevious;
    $[1] = step;
    $[2] = steps;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <ProcessSteps className="grow">{t1}</ProcessSteps>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AsideQuestion />;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2) {
    t4 = <div className="rounded-m bg-neutral-12 grow flex flex-col p-m">{t2}{t3}</div>;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default ApplicationSteps;
function _temp(button, index) {
  return button && <Button {...button} key={index} variant="outline_primary" iconColor="currentColor" />;
}